import axios from "axios";

export const CATALOGOS_API =
  process.env.REACT_APP_CATALOGOS_API_URL ||
  "https://b86a87cvk3.execute-api.us-east-1.amazonaws.com/dev";

const api = axios.create({
  baseURL: CATALOGOS_API,
  headers: {
    "Content-Type": "application/json",
  },
});

const unwrap = (response) => response.data?.data ?? response.data;

export const proyectosApi = {
  listar: async (includeInactive = false) =>
    unwrap(
      await api.get("/catalogos/proyectos", {
        params: { includeInactive },
      })
    ),

  obtener: async (id) =>
    unwrap(
      await api.get(`/catalogos/proyectos/${id}`)
    ),

  crear: async (data) =>
    unwrap(
      await api.post("/catalogos/proyectos", data)
    ),

  actualizar: async (id, data) =>
    unwrap(
      await api.put(`/catalogos/proyectos/${id}`, data)
    ),

  desactivar: async (id) =>
    unwrap(
      await api.delete(`/catalogos/proyectos/${id}`)
    ),
};

export const municipiosApi = {
  listar: async ({
    includeInactive = false,
    proyectoId = null,
  } = {}) =>
    unwrap(
      await api.get("/catalogos/municipios", {
        params: {
          includeInactive,
          ...(proyectoId ? { proyectoId } : {}),
        },
      })
    ),

  obtener: async (id) =>
    unwrap(
      await api.get(`/catalogos/municipios/${id}`)
    ),

  crear: async (data) =>
    unwrap(
      await api.post("/catalogos/municipios", data)
    ),

  actualizar: async (id, data) =>
    unwrap(
      await api.put(`/catalogos/municipios/${id}`, data)
    ),

  desactivar: async (id) =>
    unwrap(
      await api.delete(`/catalogos/municipios/${id}`)
    ),
};

export const oficinasApi = {
  listar: async ({
    includeInactive = false,
    proyectoId = null,
    municipioId = null,
  } = {}) =>
    unwrap(
      await api.get("/catalogos/oficinas", {
        params: {
          includeInactive,
          ...(proyectoId ? { proyectoId } : {}),
          ...(municipioId ? { municipioId } : {}),
        },
      })
    ),

  obtener: async (id) =>
    unwrap(
      await api.get(`/catalogos/oficinas/${id}`)
    ),

  crear: async (data) =>
    unwrap(
      await api.post("/catalogos/oficinas", data)
    ),

  actualizar: async (id, data) =>
    unwrap(
      await api.put(`/catalogos/oficinas/${id}`, data)
    ),

  desactivar: async (id) =>
    unwrap(
      await api.delete(`/catalogos/oficinas/${id}`)
    ),
};

export function getApiError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "OcurriÃ³ un error inesperado."
  );
}

export default api;